import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Rehabilitation() {
  useEffect(() => {
    document.title =
      "Rehabilitation & Physiotherapy Guidance | Viksha Health Care";
    const newMetaDescription =
      "Rehabilitation and physiotherapy guidance at Viksha Health Care. Improve strength, mobility, and function with a personalized plan.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>
        Rehabilitation & Physiotherapy Guidance
      </h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Rehabilitation-Physiotherapy-Guidance.avif" />
        </div>
        <div className="textareaofser">
          <h1>Rehabilitation & Physiotherapy Guidance</h1>

          <p>
            Rehabilitation and physiotherapy play a vital role in recovery from
            orthopaedic injuries, surgeries, and chronic joint or muscle
            conditions. Proper rehabilitation helps restore strength,
            flexibility, balance, and normal movement while reducing pain and
            preventing re-injury.
          </p>

          <p>
            A structured physiotherapy program is designed according to your
            specific condition, age, and activity level. The goal is to help you
            return to daily activities safely and confidently.
          </p>

          <h5>Benefits of Physiotherapy</h5>
          <ul>
            <li>Improves joint movement and flexibility</li>
            <li>Strengthens muscles to support injured areas</li>
            <li>Reduces pain and stiffness</li>
            <li>Enhances balance and coordination</li>
            <li>Promotes faster and safer recovery</li>
          </ul>

          <h5>When Rehabilitation Is Needed</h5>
          <ul>
            <li>After fractures or joint injuries</li>
            <li>Following orthopaedic surgeries</li>
            <li>Chronic back, neck, or joint pain</li>
            <li>Sports injuries and muscle strains</li>
            <li>Reduced mobility due to arthritis or aging</li>
          </ul>

          <h5>Key Components of Rehabilitation</h5>

          <h6>Mobility Exercises</h6>
          <p>
            Gentle movements help restore joint flexibility and prevent
            stiffness during recovery.
          </p>

          <h6>Strengthening Exercises</h6>
          <p>
            Targeted exercises improve muscle strength and joint stability,
            which helps reduce stress on injured areas.
          </p>

          <h6>Balance and Coordination Training</h6>
          <p>
            These exercises improve body control and reduce the risk of falls or
            repeat injuries.
          </p>

          <h6>Posture and Movement Correction</h6>
          <p>
            Proper posture and movement techniques are taught to prevent strain
            and support long-term musculoskeletal health.
          </p>

          <h5>Home Exercise Guidance</h5>
          <p>
            Patients are often given simple exercises to continue at home.
            Regular practice helps maintain progress and speeds up recovery.
          </p>

          <h5>Gradual Return to Activity</h5>
          <p>
            Rehabilitation includes step-by-step guidance on returning to work,
            sports, and daily tasks without overloading healing tissues.
          </p>

          <h5>Importance of Consistency</h5>
          <p>
            Regular attendance and following prescribed exercises are essential
            for successful rehabilitation. Consistency leads to better strength,
            flexibility, and long-term pain relief.
          </p>

          <p>
            With proper rehabilitation and physiotherapy guidance, most patients
            can regain confidence in movement, reduce discomfort, and return to
            an active and healthy lifestyle.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(Rehabilitation);
